// extracted by mini-css-extract-plugin
export default {"container":"Dots_container__xbFAG","dotsContainer":"Dots_dotsContainer__fm-T6","value":"Dots_value__DIZiS"};